import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'common-button',
  template: `
    <button class="common-button">{{text}}</button>`,
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

  @Input() text = '다음';

  constructor() { }

  ngOnInit(): void {
  }

}
